import type { CaptureResult } from "posthog-js";

type ErrorTrackingUser = {
  readonly userId: string;
  readonly organizationId: string | null;
};

let currentUser: ErrorTrackingUser | null = null;

export function setErrorTrackingUser(user: ErrorTrackingUser | null): void {
  currentUser = user;
}

/** Memory persistence mints an id per load; `identify` would pile them onto the person. Stamp stable id instead. */
export function attachErrorTrackingUser(
  event: CaptureResult | null,
): CaptureResult | null {
  if (event === null || currentUser === null) return event;
  event.properties.distinct_id = currentUser.userId;
  event.properties.organization_id = currentUser.organizationId;
  return event;
}
